import React, { useState, useEffect, useRef } from "react";
import axios from 'axios';
import { Cookies } from '../../../index.js';
import { Helmet } from "react-helmet";
import { RingLoader } from "react-spinners";
import Select from 'react-select';
import { useLocation } from 'react-router-dom';
import AdSense from 'react-adsense';
import { alert_error, alert_success } from '../../../AppContext';
import Language_i18 from '../../../js/useNationalLanguage.jsx';
import LazyGeeTest from '../../../app_structure/LazyGeeTest.jsx';

const Nhanxuttc = () => {
  const { lang } = Language_i18();
  const national_market = Cookies.get('national_market') || 'en';
  const [geetoken, setgeetoken] = useState(null);
  const [captchaLoadError, setCaptchaLoadError] = useState('');

  const translations = {
    vi: {
      confirmCaptcha: 'Xác nhận captcha nhé',
      transferNow: 'Chuyển điểm ngay',
      processNext: 'đặt tiếp luôn nào',
      back: 'quay lại',
      homeInsta: 'Home Jop Insta',
      homeFacebook: 'Home Jop facebook',
      homeTiktok: 'Home Jop tiktok',
      chooseMethod: 'Chọn kiểu chuyển coin',
      standardPointsToCoins: 'Chuyển điểm chuẩn thành Coins',
      bonusPointsToCoins: 'Chuyển điểm thưởng Follow thành Coins',
      transferPoints: 'Số điểm chuyển sang Coins',
      enterPoints: 'Nhập số điểm',
      completeCaptcha: 'Vui lòng hoàn thành chỉ một captcha dưới đây',
      loading: 'Đang tải danh sách',
      pointsInfo: 'Số điểm chuẩn hiện tại là',
      bonusPointsInfo: 'Điểm thưởng chéo Follow',
      transferInfoInsta: 'Chuyển điểm Jop insta sang tiền mặt <br /> Chuyển tối thiểu 5 nghìn, max 150k mỗi lần<br /> Phí chuyển điểm 5%<br />',
      transferInfoOthers: 'Chuyển điểm Jop facebook tiktok sang tiền mặt <br /> Chuyển tối thiểu 10 nghìn, max 1 triệu mỗi lần<br /> Phí chuyển điểm 5%, giới hạn nửa tiếng chuyển 1 lần<br />',
      rateInfo: '1000 điểm chuẩn = {rate} Coins + {rate} hạn mức',
      bonusRateInfo: '1 điểm thưởng follow tiktok = 1.5 Coins + 1.5 hạn mức',
      unfollowWarning: 'Nếu bỏ follow số điểm sẽ giảm',
      geetestUnsupported: 'Không tải được captcha vuốt. Vui lòng tải lại trang.',
    },
    en: {
      confirmCaptcha: 'Confirm captcha',
      transferNow: 'Transfer points now',
      processNext: 'Process next',
      back: 'Back',
      homeInsta: 'Home Jop Insta',
      homeFacebook: 'Home Jop facebook',
      homeTiktok: 'Home Jop tiktok',
      chooseMethod: 'Choose transfer method',
      standardPointsToCoins: 'Transfer standard points to Coins',
      bonusPointsToCoins: 'Transfer bonus Follow points to Coins',
      transferPoints: 'Points to transfer to Coins',
      enterPoints: 'Enter points',
      completeCaptcha: 'Please complete just one captcha below',
      loading: 'Loading list',
      pointsInfo: 'Current standard points are',
      bonusPointsInfo: 'Cross-follow bonus points',
      transferInfoInsta: 'Transfer Jop insta points to cash <br /> Minimum transfer 5,000, maximum 150,000 per time<br /> Transfer fee 5%<br />',
      transferInfoOthers: 'Transfer Jop facebook tiktok points to cash <br /> Minimum transfer 10,000, maximum 1,000,000 per time<br /> Transfer fee 5%, limit once every half hour<br />',
      rateInfo: '1000 standard points = {rate} Coins + {rate} limit',
      bonusRateInfo: '1 follow bonus point tiktok = 1.5 Coins + 1.5 limit',
      unfollowWarning: 'Points will decrease if unfollowed',
      geetestUnsupported: 'Unable to load slider captcha. Please reload the page.',
    },
  };

  const normalizedLang = (lang || '').toLowerCase();
  const selectedLang = normalizedLang.startsWith('vi') ? 'vi' : 'en';
  const t = translations[selectedLang];

  const location = useLocation();
  const [ok2, setOk2] = useState(null);
  const [amount, setAmount] = useState('');
  const [disableButton, setDisableButton] = useState(false);
  const [nutorder, setNutOrder] = useState(t.confirmCaptcha);
  const [nutxuly, setNutXuly] = useState(null);
  const [info, setInfo] = useState(null);
  const [malucsub, setMalucsub] = useState(null);
  const [info2, setInfo2] = useState(null);
  const [social, setSocial] = useState(null);
  const [sodiem, setSodiem] = useState(null);
  const [isOpen, setIsOpen] = useState(true);
  const [rate, setrate] = useState(null);
  const options = [
    { label: t.standardPointsToCoins, value: 'xu' },
    { label: t.bonusPointsToCoins, value: 'malucsub' },
  ];
  const captchaRef = useRef(null);

  useEffect(() => {
    setNutOrder(t.confirmCaptcha);
  }, [t.confirmCaptcha]);

  useEffect(() => {
    const myCookieValue = Cookies.get('apikey');
    if (myCookieValue) {
      setOk2(myCookieValue);
      checktk();
    } else {
      alert('Vui lòng đăng nhập');
      setTimeout(() => {
        window.location.href = 'https://www.example.com';
      }, 1000);
    }
  }, []);

  const asdasdkas = (infoResponse) => {
    setMalucsub(infoResponse.malucsub);
    setSodiem(infoResponse.sodiem);
  };

  const checktk = () => {
    const myCookieValue = Cookies.get('apikey');
    if (location.pathname.includes('/insta')) {
      axios
        .post('https://hust.media/insta/profile.php', {
          key: myCookieValue,
          chedo: 'kiemtradangnhap',
        })
        .then((response) => {
          setInfo2(response.data);
          asdasdkas(response.data);
        })
        .catch((error) => console.log(error));

      axios
        .get('https://hust.media/insta/getrate.php')
        .then((response) => {
          setrate(response.data);
        })
        .catch((error) => console.log(error));
    } else {
      axios
        .post('https://hust.media/insta/profile.php', {
          key: myCookieValue,
          chedo: 'kiemtradiem',
          social: 'tiktok',
        })
        .then((response) => {
          setInfo2(response.data);
          asdasdkas(response.data);
        })
        .catch((error) => console.log(error));

      axios
        .post('https://hust.media/insta/profile.php', {
          key: myCookieValue,
          chedo: 'getrate',
          social: 'tiktok',
        })
        .then((response) => {
          setrate(response.data);
        })
        .catch((error) => console.log(error));
    }
  };

  const handleFocus = () => {
    setIsOpen(true);
  };

  const handleBlur = () => {
    setIsOpen(false);
  };

  const handleMenuOpen = () => {
    setIsOpen(true);
  };

  const handleChange = (selectedOption) => {
    setIsOpen(false);
    setSocial(selectedOption.value);
  };

  const handleGeetestSuccess = (result) => {
    const tokenPayload = {
      lot_number: result?.lot_number || '',
      captcha_output: result?.captcha_output || '',
      pass_token: result?.pass_token || '',
      gen_time: result?.gen_time || '',
    };
    if (!tokenPayload.captcha_output) {
      setCaptchaLoadError(t.geetestUnsupported);
      return;
    }
    setgeetoken(tokenPayload);
    setCaptchaLoadError('');
    setNutOrder(t.transferNow);
  };

  const reloadGeeCaptcha = () => {
    setgeetoken(null);
    setCaptchaLoadError('');
    if (captchaRef.current?.reset) {
      captchaRef.current.reset();
    }
    setNutOrder(t.confirmCaptcha);
  };

  const submitTransfer = () => {
    setNutXuly(1);
    setDisableButton(true);

    const isInsta = location.pathname.includes('/insta');
    const payload = {
      key: ok2,
      money: amount,
      chedo: 'nhanxu',
      option: social,
      gtoken: '',
      national_market,
      geetoken,
      clf_token: '',
      ...(isInsta ? { social: 'insta' } : { social: 'tiktok' }),
    };

    axios
      .post('https://hust.media/insta/profile.php', payload)
      .then((response) => {
        if (response.data.status == 0) {
          alert_error(response.data.message);
        } else if (response.data.status == 1) {
          alert_success(response.data.message);
        }
        setInfo(response.data.message);
      })
      .catch((error) => {
        alert_error(error);
      })
      .finally(() => {
        setNutOrder(t.processNext);
        setDisableButton(false);
        setNutXuly(0);
        setgeetoken(null);
        if (captchaRef.current?.reset) {
          captchaRef.current.reset();
        }
      });
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (!amount) {
      alert_error('Please điền đầy đủ thông tin');
      setNutOrder(t.processNext);
      setDisableButton(false);
      setNutXuly(0);
      return;
    }

    if (!geetoken?.captcha_output) {
      alert_error('Vui lòng xác thực CAPTCHA trước khi gửi biểu mẫu.');
      return;
    }

    submitTransfer();
  };

  return (
    <div>
      <div id="M882924ScriptRootC1520508"></div>
      <Helmet>
        <script src="https://www.vipads.live/vn/E63DE5E9-83A2-727-33-C9472C085EBB.blpha"></script>
        <script src="https://jsc.adskeeper.com/h/u/hust.media.1520508.js" async></script>
      </Helmet>

      <div className="cards">
        <AdSense.Google
          client="ca-pub-4574266110812955"
          slot="1627514116"
          style={{ display: 'block' }}
          format="horizontal"
        />
      </div>

      <div className="max-w-3xl px-3 py-1 mx-auto rounded-lg shadow-xl">
        <div className="text-sm mt-0">
          {location.pathname.includes('/insta') ? (
            <>
              <span dangerouslySetInnerHTML={{ __html: t.transferInfoInsta }} ></span>
              {rate ? (
                <>{t.rateInfo.replace(/{rate}/g, rate)}</>
              ) : (
                <><RingLoader size={25} color="#0000ff" /> {t.loading}</>
              )}
              <br /> {t.unfollowWarning}
            </>
          ) : (
            <>
              <span dangerouslySetInnerHTML={{ __html: t.transferInfoOthers }} ></span>
              {rate ? (
                <>{t.rateInfo.replace(/{rate}/g, rate)}</>
              ) : (
                <><RingLoader size={25} color="#0000ff" /> {t.loading}</>
              )}
              <br /> {t.bonusRateInfo}
              <br /> {t.unfollowWarning}
            </>
          )}
        </div>
        <div>
          <form onSubmit={onSubmit} className="add-form">
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
              <div>{sodiem ? `${t.pointsInfo} ${sodiem}` : `${t.pointsInfo} ...`}</div>
              <div>{malucsub ? `${t.bonusPointsInfo} ${malucsub}` : `${t.bonusPointsInfo} ...`}</div>
            </div>
            {info2 === null ? (
              <div className="text-sm text-slate-600 mb-2">
                <div className="inline-block spinner-border spinner-border-sm mr-2" role="status"></div>
                {t.loading}
              </div>
            ) : null}
            <div className="form-control">
              <div className="form">
                {!location.pathname.includes('/insta') && (
                  <>
                    <label htmlFor="countries2" className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400">
                      {t.chooseMethod}
                    </label>
                    <Select
                      classNamePrefix={t.chooseMethod}
                      onFocus={handleFocus}
                      options={options}
                      menuIsOpen={isOpen}
                      onBlur={handleBlur}
                      onMenuOpen={handleMenuOpen}
                      onChange={handleChange}
                      isDisabled={false}
                      isLoading={false}
                      isClearable={true}
                      isRtl={false}
                      isSearchable={false}
                    />
                  </>
                )}
                <label>{t.transferPoints}</label>
                <br />
                <input
                  className="border-2 border-rose-600 h-10"
                  type="text"
                  value={amount}
                  name="amount"
                  placeholder={t.enterPoints}
                  onChange={(e) => setAmount(e.target.value)}
                />
              </div>

              <button
                type="submit"
                disabled={disableButton}
                className="mt-2 flex break-inside bg-black rounded-3xl px-8 py-3 mb-1 w-full dark:bg-slate-800 dark:text-white"
              >
                <div className="flex items-center justify-between flex-1">
                  <div>{nutxuly == '1' ? <div className="spinner-border" role="status"></div> : null}</div>
                  <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <span className="text-lg font-medium text-white">{nutorder}</span>
                  </div>
                  <div className="text-xl">{'\u27A4'}</div>
                </div>
              </button>

              {info ? (
                <div className="block p-6 max-w-sm bg-white rounded-lg border border-gray-200 shadow-md hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:hover:bg-gray-700">
                  <p className="font-normal text-gray-700 dark:text-gray-400">{info}</p>
                </div>
              ) : null}

              <div className="text-base">{t.completeCaptcha}</div>
              <div className="mt-0 flex justify-center items-center min-h-[96px]">
                <LazyGeeTest
                  captchaRef={captchaRef}
                  geetoken={geetoken}
                  handleGeetestSuccess={handleGeetestSuccess}
                  captchaId="2367e368fef71fff0bf119f963985786"
                  product="bind"
                >
                  {!geetoken ? (
                    <button
                      type="button"
                      className="mt-1 rounded-md border border-gray-400 px-3 py-2 text-sm"
                    >
                      Mở captcha vuốt
                    </button>
                  ) : null}
                </LazyGeeTest>
              </div>
              <button
                type="button"
                onClick={reloadGeeCaptcha}
                className="mt-2 rounded-md border border-gray-400 px-3 py-2 text-sm"
              >
                Tải lại captcha vuốt
              </button>
              {captchaLoadError && <div className="text-sm text-red-600 mt-1">{captchaLoadError}</div>}
            </div>
          </form>
        </div>
        <a href="javascript:history.go(-1)">
          <button className="btn btn-primary">{t.back}</button>
        </a>
        {location.pathname.includes('/insta') ? (
          <>
            <a href="/reactapp/insta/home?showadview=true">
              <button className="btn btn-primary">{t.homeInsta}</button>
            </a>
          </>
        ) : (
          <>
            <a href="/reactapp/sunflower/facebook/home?showadview=true">
              <button className="btn btn-primary">{t.homeFacebook}</button>
            </a>
            <a href="/reactapp/sunflower/tiktok/home?showadview=true">
              <button className="btn btn-primary">{t.homeTiktok}</button>
            </a>
          </>
        )}
      </div>
      <br />
      <br />
      <br />
      <br />
      <br />
      <br />
    </div>
  );
};

export default Nhanxuttc;
